module.exports = __webpack_public_path__ + "static/media/balmain_1.cde2d4f7.jpg";